module.exports = __webpack_public_path__ + "static/media/weatherapp.9958fbfb.png";